// import { initColorMode } from "./theme/colorMode"; // TODO: activate Darkmode

import changeEventForInput from "./helper/autofill-events";
import vanillaJSdocumentReadyHelper from "./helper/document-ready-helper";
import animateContentOnScroll from "./helper/animate-content-on-scroll";
import animateBarOnScroll from "./helper/animate-bar-on-scroll";
import initVideoThumb from "./theme/videoThumbnails";

import { scrollToID } from "./helper/helper";
import { initToggleDropdown } from "./partials/mb-navigation";
import { initNavIcon } from "./partials/mb-nav-icon";
import { configLibraries } from "./theme/configLibraries";
import { linkWrapperClickHandler, initWatchHover } from "./theme/clickHandler";
import { initSingleStoreImageSlider } from "./partials/mb-single-store";
import { initSingleNewsImageSlider } from "./partials/mb-single-news";
import { initMbSearch } from "./partials/mb-search";
// import { mbYoutubeBorlabsGate } from "./partials/mb-youtube-borlabs-gate";
import { initReadmore, updateReadMore } from "./partials/mb-readmore";
import { initContactForm7SubmitLock } from "./partials/mb-contact-form-7";

import { printDeveloperMessageToConsole } from "./helper/mbagentur";

/**
 * Init JS Helper
 */
vanillaJSdocumentReadyHelper();
changeEventForInput();

(function () {
  function init() {
    // // Get styling informations from css property values
    // const style = getComputedStyle(document.body);
    // const max_mainwidth = style.getPropertyValue("--maxMainWidth");

    // // TODO: activate Darkmode
    // initColorMode();

    initNavIcon();
    initToggleDropdown();
    configLibraries();
    linkWrapperClickHandler();
    initWatchHover();
    animateContentOnScroll();
    animateBarOnScroll();
    // mbYoutubeBorlabsGate();
    initSingleStoreImageSlider();
    initSingleNewsImageSlider();
    initVideoThumb();
    initMbSearch();
    initReadmore();
    initContactForm7SubmitLock();

    printDeveloperMessageToConsole();
  }

  init();

  // On document ready
  docReady(function (context) {});
})();

/**
 * Remove page loader
 */
jQuery(window).on("load", function () {
  jQuery(".mb-loader-wrapper").fadeOut("slow");
});

/**
 * Smooth Anker scrolling
 */
jQuery('a[href*="#"]').on("click", function (e) {
  var target = this.hash;
  var $target = jQuery(target);

  if ($target.length > 0) {
    e.preventDefault();
    jQuery("html, body")
      .stop()
      .animate(
        {
          scrollTop: $target.offset().top - 100,
        },
        900,
        "swing",
        function () {
          //window.location.hash = target;
        }
      );
  }
});

document.addEventListener("DOMContentLoaded", function () {
  let current_url = window.location.href;
  let current_hash = window.location.hash;

  if (current_hash.length > 0) {
    // prevent page jump on load
    window.location.hash = "";

    var target = current_hash;
    var $target = jQuery(target);
    var targetArray = Array.from(jQuery(target));

    setTimeout(function () {
      jQuery("html, body")
        .stop()
        .animate(
          {
            scrollTop: $target.offset().top - 100,
          },
          900,
          "swing",
          function () {
            // window.location.hash = target;
          }
        );
    }, 1500);
  }
});

jQuery(window).scroll(function() {
  var scroll = jQuery(window).scrollTop();

  if (scroll >= 1) {
      jQuery("#mb-section-main-menu").addClass("scrolling");
  } else {
      jQuery("#mb-section-main-menu").removeClass("scrolling");
  }
});

document.addEventListener('DOMContentLoaded', function() {
  var scroll = jQuery(window).scrollTop();

  if (scroll >= 1) {
      jQuery("#mb-section-main-menu").addClass("scrolling");
  }
});
